"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMatch = void 0;
const round_model_1 = require("./round.model");
/**
 * Creates a rich Match object from a raw MatchState.
 *
 * @param {MatchState} state The raw state of the match.
 * @returns {Match} A new Match object with navigation functions.
 */
const createMatch = (state) => {
    // Memoize round creations for efficiency
    const rounds = state.rounds.map((rs) => (0, round_model_1.createRound)(rs));
    const currentRound = rounds[rounds.length - 1];
    return {
        getUnderlyingState: () => state,
        getCurrentRound: () => currentRound,
        getRound: (roundId) => {
            return rounds[roundId];
        },
        getPreviousRound: (currentRound) => {
            const roundId = currentRound.getRoundId();
            if (roundId === 0) {
                return undefined;
            }
            return rounds[roundId - 1];
        },
        getHomeTeam: () => state.teams[state.homeTeam],
        getAwayTeam: () => state.teams[state.awayTeam],
        getTeam: (teamId) => state.teams[teamId],
    };
};
exports.createMatch = createMatch;
